module.exports = __webpack_public_path__ + "07_long_brown.c5d0d36d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_long_brown.png
// module id = 3Rx+
// module chunks = 0